import * as yup from "yup";

export const insumoSchema = yup.object().shape({
  nome: yup.string().required("O nome é obrigatório"),
  unidade: yup.string().required("A unidade é obrigatória"),
  quantidade: yup.number()
    .typeError("Quantidade inválida")
    .required("Quantidade inválida")
});
